<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="form__title primary--text mb-5">
          DADOS DO ESCRITÓRIO
        </p>
      </v-col>
      <v-col cols="12">
        <div class="d-flex mb-4">
          <v-switch
            v-model="value.restrito"
            class="pa-0 ma-0"
            color="secondary"
            inset
            hide-details
            dense
          />
          <p class="darkBluishGray--text caption mb-0">
            Visualização Restrita?
          </p>
        </div>
      </v-col>
      <v-col cols="12" class="pb-5" v-if="isEdit">
        <v-switch
          v-model="value.ativo"
          class="pa-0 ma-0 justify-self-center d-inline-block base-form-switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          {{ statusSwitch }}
        </p>
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <DocumentInput
          id-element="cnpjOffice"
          placeholder="Inserir"
          v-model="value.cnpj"
          required
          :rules="[requiredInput, isValidCnpjDocument]"
          label-text="CNPJ"
          validate-on-blur
          document-type="cnpj"
        />
      </v-col>
      <v-col cols="12" sm="8">
        <BaseFormInput
          id-element="cnpjOffice"
          placeholder="Inserir"
          v-model="value.razao_social"
          required
          :rules="[requiredInput]"
          label-text="Razão Social"
          validate-on-blur
        />
      </v-col>
      <v-col cols="12" sm="8">
        <BaseFormInput
          id-element="cnpjOffice"
          placeholder="Inserir"
          v-model="value.nome_fantasia"
          required
          :rules="[requiredInput]"
          label-text="Nome Fantasia"
          validate-on-blur
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <ModalityPermissionsModal v-if="permissionsModal" v-model="permissionsModal" @close="closeModal" :economicGroupId="selectedEconomicGroup.id" :targetAPI="'escritorios'" :targetId="this.form.id"/>
    <BaseTab v-if="isEdit" class="pt-8">
      <v-tab>GRUPOS ECONÔMICOS VINCULADOS</v-tab>
      <v-tab>APÓLICES VINCULADAS</v-tab>
      <v-tab>COTAÇÕES VINCULADAS</v-tab>
      <v-tab-item class="py-10">
        <BaseDataTable
          :headers="tableHeadersEconomicGroup"
          :items="form.grupos_economicos"
          no-data-text="Não há grupos econômicos vinculados."
          dense
        >
          <template v-slot:[`item.nome`]="{ item }">
            <v-row>
              <v-col style="line-height:40px">
                  {{ item.nome }}
              </v-col>
              <v-col class="d-flex justify-sm-end">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <BaseButton
                        color="secondary"
                        class="px-0 mr-2"
                        @click="openModal(item)"
                      >
                        <v-icon>
                          $vuetify.icons.permissions
                        </v-icon>
                      </BaseButton>
                    </div>
                  </template>
                  <span>
                    Editar Permissões
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </BaseDataTable>
      </v-tab-item>
      <v-tab-item class="py-10">
        <BaseDataTable
          :headers="tableHeadersPolicy"
          :items="policies.items"
          no-data-text="Não há grupos econômicos vinculados."
          class="office-form-table"
        >
          <template v-slot:[`item.numero`]="{ item }">
            <div :class="borderColor(item.situacao.id)">
              {{ item.numero }}
            </div>
          </template>
          <template v-slot:[`item.valor_importancia_segurada`]="{ item }">
            {{ asMoneyString(item.valor_importancia_segurada) }}
          </template>
          <template v-slot:[`item.inicio_vigencia`]="{ item }">
            {{ formatDateToDDMMYYYY(item.inicio_vigencia) }} à
            {{ formatDateToDDMMYYYY(item.fim_vigencia) }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            {{ item.situacao.nome }}
            <fragment v-if="item.tem_solicitacao_cancelamento_aberta">
              <v-tooltip bottom content-class="tooltip-label-form">
                <template v-slot:activator="{ on }">
                  <img src="@/assets/ic_warning.svg" class="px-1" v-on="on" />
                </template>
                <div class="px-4 py-3">
                  <p class="white--text tooltip-label-text mb-0">
                    Cancelamento solicitado por
                    {{ item.cancelamento_solicitado_por.nome }} em
                    {{
                      formatIsoDateToDDMMYYYY(item.cancelamento_solicitado_em)
                    }}
                  </p>
                </div>
              </v-tooltip>
            </fragment>
          </template>
        </BaseDataTable>
      </v-tab-item>
      <v-tab-item class="py-10">
        <BaseDataTable
          :headers="tableHeadersQuotation"
          :items="quotations.items"
          no-data-text="Não há grupos econômicos vinculados."
          class="office-form-table"
        >
          <template v-slot:[`item.numero`]="{ item }">
            <div :class="borderColor(item.status.id)">
              {{ item.numero }}
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{ item.status.nome }}
          </template>
        </BaseDataTable>
      </v-tab-item>
    </BaseTab>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3" xl="2" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
            @click="$emit('cancel')"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" xl="2">
          <BaseButton
            v-html="textButton"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import ModalityPermissionsModal from "./ModalityPermissionsModal.vue"
import { requiredInput, isValidCnpjDocument } from "@/utils/rules.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import DocumentInput from "@/components/form/DocumentInput.vue";
import { normalizeCnpj } from "@/utils/documents.js";
import _ from "lodash";
import {
  asMoneyString,
  formatDateToDDMMYYYY,
  formatIsoDateToDDMMYYYY
} from "@/utils/formats.js";
const tableHeadersEconomicGroup = [
  { text: "Grupo Econômico", value: "nome", sortable: true }
];
const tableHeadersPolicy = [
  { text: "N° da Apólice", value: "numero", sortable: true },
  {
    text: "Tomador Matriz/Filial",
    value: "tomador.nome_fantasia",
    sortable: true
  },
  {
    text: "Valor Segurado",
    value: "valor_importancia_segurada",
    sortable: true
  },
  { text: "Vigência", value: "inicio_vigencia", sortable: true },
  { text: "Status", value: "situacao", sortable: true }
];
const tableHeadersQuotation = [
  { text: "N° da Solicitação", value: "numero", sortable: true },
  {
    text: "Tomador Matriz/Filial",
    value: "tomador.nome_fantasia",
    sortable: true
  },
  { text: "Reclamante", value: "segurado.nome", sortable: true },
  { text: "Status", value: "status", sortable: true }
];

const colorByStatus = {
  ativo: { color: "light-green" },
  ativa: { color: "light-green" },
  cancelada: { color: "pink" },
  renovada: { color: "blue" },
  vencida: { color: "pink" },
  apolice_emitida: { color: "blue" },
  aguardando_emissao_minuta: { color: "light-green" },
  aguardando_analise_minuta: { color: "light-green" },
  em_andamento: { color: "yellow" }
};

const DEFAULT_STATUS_COLOR = { color: "yellow" };

export default {
  components:{
    ModalityPermissionsModal,
    DocumentInput
  },
  data: () => ({
    tableHeadersEconomicGroup,
    tableHeadersPolicy,
    tableHeadersQuotation,
    requiredInput,
    isValidCnpjDocument,
    value: {},
    oldCNPJ: null,
    asMoneyString,
    formatDateToDDMMYYYY,
    formatIsoDateToDDMMYYYY,
    permissionsModal: false,
    selectedEconomicGroup: null
  }),
  mixins: [LoadingRequest],
  computed: {
    ...mapState("insuranceCompany", ["currentLegalPerson"]),
    ...mapState("office", ["quotations", "policies"]),
    statusSwitch() {
      const value = this.value.ativo ? "Ativo" : "Inativo";
      return `Status: ${value}`;
    }
  },
  created() {
    this.value = this.form;
    this.oldCNPJ = normalizeCnpj(_.cloneDeep(this.form.cnpj));
  },
  methods: {
    ...mapActions("economic_group", ["findLegalPerson"]),
    ...mapActions("insuranceCompany", ["requestLegalPerson"]),
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.value);
    },
    fetchLegalPerson(cnpj) {
      this.withLoading(this.requestLegalPerson(cnpj));
    },
    borderColor(status) {
      const { color } = colorByStatus[status] || DEFAULT_STATUS_COLOR;
      return `office-form-table__border office-form-table__border-${color}`;
    },
    closeModal() {
      this.permissionsModal = false;
    },
    openModal(item) {
      this.selectedEconomicGroup = item;
      this.permissionsModal = true;
    }
  },
  props: {
    form: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String
    }
  },
  watch: {
    "value.cnpj"(value) {
      const cnpj = normalizeCnpj(value);
      if (cnpj.length === 14) {
        this.fetchLegalPerson(cnpj);
      }
    },
    currentLegalPerson(value) {
      if (value && normalizeCnpj(this.value.cnpj) != this.oldCNPJ) {
        this.value.razao_social = value.razao_social || this.value.razao_social;
        this.value.nome_fantasia =
          value.nome_fantasia || this.value.nome_fantasia;
      }
    }
  }
};
</script>
<style lang="sass">
.office-form-table
  .v-data-table__wrapper
    @media (min-width:960px)
      overflow: visible !important
  td
    position: relative
  &__border::before
    overflow: visible !important
    display: block
    position: absolute
    background-color: #CCC
    width: 5px
    border-radius: 2px
    top: 8px
    bottom: 8px
    left: 0px
    margin-left: -3px
    content: " "
  &__border-blue::before
    background-color: var(--v-secondary-base) !important
  &__border-yellow::before
    background-color: var(--v-yellow-base) !important
  &__border-light-green::before
    background-color: var(--v-lightGreen-base) !important
  &__border-pink::before
    background-color: var(--v-pink-base) !important
</style>